import basicdata from '@manage/api/api.basicdata'
export default [
  {
    type: 'select',
    placeholder: '品牌',
    filed: 'brand',
    default: '',
    query: basicdata.basic_wine_select + '?type=1',
    labelOptions: {
      key: 'name',
      value: 'name'
    }
  },
  {
    type: 'select',
    placeholder: '分类',
    filed: 'classify',
    default: '',
    query: basicdata.basic_wine_select + '?type=2',
    labelOptions: {
      key: 'name',
      value: 'name'
    }
  },
  {
    type: 'select',
    placeholder: '产地',
    filed: 'origin',
    default: '',
    query: basicdata.basic_wine_select + '?type=3',
    labelOptions: {
      key: 'name',
      value: 'name'
    }
  },
  {
    type: 'select',
    placeholder: '容量',
    filed: 'capacity',
    default: '',
    query: basicdata.basic_wine_select + '?type=4',
    labelOptions: {
      key: 'name',
      value: 'name'
    }
  },
  {
    type: 'select',
    placeholder: '类型',
    filed: 'type',
    default: '',
    query: basicdata.basic_wine_select + '?type=5',
    labelOptions: {
      key: 'name',
      value: 'name'
    }
  },
  {
    type: 'select',
    placeholder: '酒柜类型',
    filed: 'room',
    default: '',
    options: [
      {
        code: 1,
        name: '单间室'
      },
      {
        code: 2,
        name: '双间室'
      }
    ]
  }
]
